import React from 'react';
import { Box, Flex, IconButton, Heading } from 'pounceV2';

const NotificationsHeaderV3 = ({
  onToggleSettings,
}: {
  onToggleSettings: (flag: boolean) => void;
}) => {
  return (
    <Flex justify="space-between" fontWeight="bold" align="center" p={6}>
      <Heading variant="h5" fontWeight="bold" mr={2}>
        Notifications
      </Heading>
      <Box>
        <IconButton
          variant="outline"
          icon="settings-line"
          size="small"
          title="Toggle Notification Settings"
          aria-label="Toggle Notification Settings"
          onClick={() => onToggleSettings(true)}
        />
      </Box>
    </Flex>
  );
};

export default NotificationsHeaderV3;
